import { useState } from 'react';
import { FolderOpen, Plus } from 'lucide-react';
import { Button } from '../../components/ui/button';
import { useCases } from '../../hooks/use-cases';
import { CaseCard } from './case-card';
import { CasesSkeleton } from './cases-skeleton';
import { NewCaseDialog } from './new-case-dialog';
import { PendingInvitationsBanner } from './pending-invitations-banner';

function EmptyState() {
  return (
    <div className="flex flex-col items-center gap-2 py-16 text-center">
      <FolderOpen size={28} className="text-[#3e404e]" />
      <p className="text-sm text-[#5e6070]">Ingen saker funnet</p>
    </div>
  );
}

export function CasesPage() {
  const { data: cases, isLoading, isError } = useCases();
  const [isNewCaseOpen, setIsNewCaseOpen] = useState(false);

  return (
    <div className="mx-auto w-full max-w-2xl px-4 py-8">
      <div className="mb-6 flex items-center justify-between">
        <h1 className="text-base font-semibold text-[#ededf0]">Saker</h1>
        <div className="flex items-center gap-3">
          {cases && (
            <span className="text-xs text-[#5e6070]">
              {cases.length} {cases.length === 1 ? 'sak' : 'saker'}
            </span>
          )}
          <Button className="px-3 py-1.5 text-xs" onClick={() => setIsNewCaseOpen(true)}>
            <Plus size={13} />
            Ny sak
          </Button>
        </div>
      </div>

      <PendingInvitationsBanner />

      {isError && (
        <p className="rounded-md bg-danger/[0.08] px-3 py-2 text-xs text-danger/80">
          Kunne ikke laste saker. Prøv igjen.
        </p>
      )}

      {isLoading && <CasesSkeleton />}

      {!isLoading && !isError && cases && (
        <>
          {cases.length === 0 ? (
            <EmptyState />
          ) : (
            <div className="flex flex-col gap-2">
              {cases.map((c) => (
                <CaseCard key={c.id} caseItem={c} />
              ))}
            </div>
          )}
        </>
      )}

      {isNewCaseOpen && <NewCaseDialog onClose={() => setIsNewCaseOpen(false)} />}
    </div>
  );
}
